module.exports = __webpack_public_path__ + "static/media/swift.1fad20e8.png";